(() => {
  // Flag so CSS can collapse ONLY when JS is active
  document.documentElement.classList.add('hnt-menu-js');

  function initMenuDrawer(drawer) {
    const nav = drawer.querySelector('.menu-drawer__navigation');
    if (!nav) return;

    const parents = nav.querySelectorAll('li.menu-drawer__list-item--flat');

    parents.forEach((li) => {
      const link = li.querySelector(':scope > a.menu-drawer__menu-item--mainlist');
      const child = li.querySelector(':scope > ul.menu-drawer__menu--childlist');
      if (!link || !child) return;

      // Prevent double-init
      if (li.querySelector(':scope > button.hnt-submenu-toggle')) return;

      // Wrap link + toggle in a row container
      const row = document.createElement('div');
      row.className = 'hnt-parent-row';

      // Move link into row
      row.appendChild(link);

      // Create toggle button
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hnt-submenu-toggle';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', 'Toggle submenu');
      btn.innerHTML = '<span class="hnt-chevron" aria-hidden="true"></span>';

      row.appendChild(btn);

      // Put row back at top of LI
      li.insertBefore(row, li.firstChild);

      // Start collapsed
      li.classList.add('hnt-has-submenu');
      li.classList.remove('hnt-open');
      child.hidden = true;

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const isOpen = li.classList.toggle('hnt-open');
        btn.setAttribute('aria-expanded', String(isOpen));
        child.hidden = !isOpen;
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.menu-drawer').forEach(initMenuDrawer);
  }

  // 1) Run on load
  document.addEventListener('DOMContentLoaded', initAll);

  // 2) Run when Shopify editor reloads sections
  document.addEventListener('shopify:section:load', initAll);

  // 3) Run after drawer opens / DOM is injected
  // This is the key bit that fixes your "0 toggles" issue.
  document.addEventListener('click', () => {
    setTimeout(initAll, 50);
  });
})();
